import $ from "jquery";

const quantityProduct = () => {
  const init = () => {
    handleClickAction();
  };

  const handleClickAction = () => {
    const el = {
      minus: ".js-product-button-minus",
      plus: ".js-product-button-plus",
    };

    if ($(el.minus).length === 0) return;

    $(document).on("click", el.minus, function (e) {
      e.preventDefault();
      const dataFor = $(this).data("for");

      let currentValue = $(`#${dataFor}`).val();
      if (currentValue > 0) {
        $(`#${dataFor}`).val(currentValue - 1);
        const buttonSubmit = $(`#${dataFor}`)
          .parents(".wrapper-btn")
          .find("button.js-add2cart");

        if (currentValue == 1) {
          $(this).addClass("disabled");
          buttonSubmit.attr("aria-disabled", true);
          buttonSubmit.attr("disabled", true);
        } else {
          buttonSubmit.attr("aria-disabled", false);
          buttonSubmit.removeAttr("disabled");
        }

        $(this).parent().find(el.plus).removeClass("disabled");
      }
    });

    $(document).on("click", el.plus, function (e) {
      e.preventDefault();
      const dataFor = $(this).data("for");

      const currentValue = $(`#${dataFor}`).val();
      const maxValue = $(`#${dataFor}`).attr("max");

      const action = () => {
        $(`#${dataFor}`).val(Number(currentValue) + 1);
        const buttonSubmit = $(`#${dataFor}`)
          .parents(".wrapper-btn")
          .find("button.js-add2cart");
        buttonSubmit.attr("aria-disabled", false);
        buttonSubmit.removeAttr("disabled");

        $(this).parent().find(el.minus).removeClass("disabled");
      };

      if (maxValue == "") {
        action();
      } else {
        if (currentValue < Number(maxValue)) {
          if (currentValue == Number(maxValue) - 1) {
            $(this).addClass("disabled");
          }
          action();
        }
      }
    });
  };

  init();
};

try {
  quantityProduct();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
